<template>
  <div>
    <v-btn
      v-if="canMassEdit && selectedItems.length > 0 && showBatch"
      class="ml-2"
      outlined
      style="background: white; position: relative"
      @click="startMassEdit"
    >
      <v-icon
        left
        style="position: relative"
      >
        mdi-format-list-checks
      </v-icon>
      <div
        class="text-truncate"
        style="position: relative"
      >
        {{ $t('Batch') }}
      </div>
    </v-btn>

    <v-dialog
      v-model="showMultipleEditDialog"
      max-width="600px"
    >
      <v-card tile>
        <div class="pa-4">
          <div v-if="massEditStep === 0">
            <div>
              <div
                class="text-h4 mb-4 mt-2 d-flex align-center"
                @click="showMultipleEditDialog = false"
              >
                <v-icon left>
                  mdi-arrow-left
                </v-icon>
                <div class="text-h4">
                  {{ $t('BatchEditTitle') }}
                </div>
              </div>
              <div>
                <v-tabs
                  color="primary darken-2"
                  grow
                >
                  <v-tab @click="changeOperationMode(0)">
                    {{ $t('BatchOverwrite') }}
                  </v-tab>
                  <v-tab
                    v-if="addableFields.length > 0"
                    @click="changeOperationMode(1)"
                  >
                    {{ $t('BatchInclude') }}
                  </v-tab>
                  <v-tab @click="changeOperationMode(2)">
                    {{ $t('BatchDelete') }}
                  </v-tab>
                </v-tabs>
              </div>
              <div class="pa-2">
                <div class="text-body-2 text--secondary mt-2 d-flex align-start">
                  <v-icon
                    class="mr-2"
                    small
                  >
                    mdi-help-circle
                  </v-icon>
                  <div>
                    <template v-if="operationMode === 0">
                      {{ $t('BatchApplySetAttributesToElements') }}
                    </template>
                    <template v-if="operationMode === 1">
                      {{ $t('BatchAddAttributeHint') }}
                    </template>
                    <template v-if="operationMode === 2">
                      {{ $t('PermanentlyDeleteSelectedItems') }}
                    </template>
                  </div>
                </div>

                <div class="mt-4">
                  <template v-if="operationMode === 1">
                    <div
                      class="mb-4 d-flex align-center text-body-1"
                      style="position: sticky;top: 0;z-index: 1"
                    >
                      {{ $t('ChooseAttributes') }}
                    </div>
                    <div
                      style="max-height: 400px; overflow-y: scroll;overscroll-behavior: contain;"
                    >
                      <template v-for="(field) in addableFields">
                        <div :key="field.value">
                          <form-field
                            :edited-item="targetItem"
                            :field="field"
                            :hide-select="true"
                          />
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-if="operationMode === 0">
                    <div
                      class="mb-4 d-flex align-center"
                      style="position: sticky;top: 0;z-index: 1"
                    >
                      {{ $t('ChooseProperties') }}
                    </div>
                    <div
                      style="max-height: 400px; overflow-y: scroll;overscroll-behavior: contain;"
                    >
                      <template v-for="(field) in editableFields">
                        <div :key="field.value">
                          <form-field
                            :edited-item="targetItem"
                            :field="field"
                            :hide-select="true"
                          />
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-if="operationMode === 2">
                    <div>
                      <div class="text-body-1">
                        {{ $t('OnceDeletedCannotRecovered') }}
                      </div>
                      <div class="mt-2 text-body-2">
                        {{ $t('PleaseConfirmSelectedItemsDeleted') }}
                      </div>
                    </div>
                  </template>
                </div>
                <div class="mt-4 text-body-2 mb-4">
                  {{ $t('CurrentSelected') }}：{{
                    selectedItems.length + ' ' + $t('Pice')
                  }}
                </div>
                <v-card
                  class="d-flex align-center justify-center pa-4 pr-0 mt-auto mb-0"
                  color="amber lighten-4 black--text"
                  elevation="0"
                  style="border-radius: 12px"
                  @click="massiveEdit(operationMode)"
                >
                  <div>
                    <template v-if="operationMode === 1">
                      {{ $t('BatchInclude') }}
                    </template>
                    <template v-if="operationMode === 0">
                      {{ $t('BatchOverwrite') }}
                    </template>
                    <template v-if="operationMode === 2">
                      {{ $t('IrrevocablyDelete') }}
                    </template>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <v-card
            v-else
            flat
            min-height="400"
          >
            <div
              v-if="massLoading"
              class="d-flex justify-center align-center"
              style="height: 600px"
            >
              <v-progress-circular indeterminate />
            </div>
            <div
              v-else
              class="d-flex flex-column justify-center align-center"
              style="height: 600px"
            >
              <div class="text-h3">
                {{ $t('BatchComplete') }}
              </div>
              <div class="mt-4">
                <template v-if="$i18n.locale === 'zh'">
                  {{
                    '操作结果：' + '' + progress + '个成功。 共操作了' + maxProgress + ', 其中失败了' + (maxProgress - progress) + '个'
                  }}
                </template>
                <template v-else>
                  {{
                    $t('BatchResult') + ': ' + $t('BatchSuccess') + ' ' + progress + ' ' + $t(
                      'from') + ' ' + maxProgress + ' ' + $t('Pice') + ', ' + $t(
                      'BatchFailed') + ' ' + (maxProgress - progress) + ' ' + $t('Pice')
                  }}
                </template>
              </div>
              <div class="mt-4">
                <v-btn
                  color="amber lighten-4 black--text"
                  elevation="0"
                  min-width="120"
                  @click="closeDialog"
                >
                  <v-icon left>
                    mdi-check
                  </v-icon>
                  {{ $t('Finish') }}
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormField from './FormField.vue'
import IKUtils from 'innerken-js-utils'
import { uniq } from 'lodash-es'

export default {
  name: 'BatchOperations',
  components: {
    FormField
  },
  props: {
    showBatch: {
      type: Boolean,
      default: true
    },
    selectedItems: {
      type: Array,
      required: true
    },
    editableFields: {
      type: Array,
      required: true
    },
    addableFields: {
      type: Array,
      required: true
    },
    canMassEdit: {
      type: Boolean,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    useUUid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMultipleEditDialog: false,
      targetItem: {},
      massEditSearch: '',
      massEditStep: 0,
      operationMode: 0,
      massLoading: false,
      progress: 0,
      maxProgress: 0
    }
  },
  methods: {
    startMassEdit () {
      this.targetItem = {}
      this.massEditSearch = ''
      this.massEditStep = 0
      this.operationMode = 0
      this.massLoading = false
      this.progress = 0
      this.showMultipleEditDialog = true
    },
    changeOperationMode (newMode) {
      this.operationMode = newMode
      this.targetItem = {}
    },
    closeDialog () {
      this.showMultipleEditDialog = false
    },
    actionsFactory (operationMode, requiredItems = null) {
      const selectedItems = requiredItems ?? this.selectedItems
      const actions = []

      if (operationMode === 1) {
        // add
        Object.keys(this.targetItem).forEach(key => {
          if (this.targetItem[key]) {
            selectedItems.forEach(it => {
              it[key] = uniq([it[key], this.targetItem[key]].flat(3))
            })
          }
        })
        selectedItems.forEach(item => {
          actions.push(async () => await this.updateItem(item))
        })
      } else if (operationMode === 0) {
        // overwirte
        selectedItems.forEach(item => {
          actions.push(async () => await this.updateItem(IKUtils.extend(item, this.targetItem)))
        })
      } else {
        selectedItems.forEach(item => {
          actions.push(async () => await this.deleteItem(item, false))
        })
      }
      return actions
    },
    async updateItem (item) {
      return await IKUtils.safeCallFunction(this.model, this.model.edit, item)
    },
    async deleteItem (item, promt = false) {
      if (promt) {
        const res = await IKUtils.showConfirmAsyn(
          this.$t('are_you_sure'),
          this.$t('you want to delete this item?')
        )
        if (res.isConfirmed) {
          await IKUtils.safeCallFunction(this.model, this.model.remove, this.useUUid ? item.uuid : item.id)
          IKUtils.toast(this.$t('delete_success'))
          this.$emit('reload')
        }
      } else {
        await IKUtils.safeCallFunction(this.model, this.model.remove, this.useUUid ? item.uuid : item.id)
        IKUtils.toast(this.$t('delete_success'))
        this.$emit('reload')
      }
    },
    async massiveEdit (operationMode) {
      this.massEditStep = 1
      this.massLoading = true
      const actions = this.actionsFactory(operationMode)
      const result = []
      for (const action of actions) {
        try {
          await action()
          result.push({ ok: true })
        } catch (e) {
          console.log('fail')
          result.push({
            ok: false,
            message: e.message
          })
        }
      }
      IKUtils.toast(this.$t('edit_success'))
      this.maxProgress = result.length
      this.progress = result.filter(it => it.ok).length
      this.targetItem = {}
      this.$emit('update:selectedItems', [])
      this.$emit('reload')
      this.massLoading = false
    }
  }
}
</script>
